/**
 * Flattens react-hook-form FieldErrors (nested objects) into path → message.
 * Paths use dot notation, e.g. `stores.01ABC.hours`.
 */
export function flattenFormErrors(
  errors: unknown,
  prefix = "",
): Record<string, string> {
  const result: Record<string, string> = {};
  if (!errors || typeof errors !== "object") return result;

  for (const [key, value] of Object.entries(
    errors as Record<string, unknown>,
  )) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (!value || typeof value !== "object") continue;

    const message = (value as { message?: unknown }).message;
    if (typeof message === "string" && message !== "") {
      result[path] = message;
      continue;
    }
    Object.assign(result, flattenFormErrors(value, path));
  }
  return result;
}
